import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e7c23b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "svg-inline",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M1 6.5L6 1.5L11 6.5",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "svg-inline",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M1 6.5L6 1.5L11 6.5",
  stroke: "black",
  "stroke-width": "2",
  transform: "rotate(180 6 4)"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.expanded)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}